import React, { createContext, useContext, useState } from "react";

const PaginatedArticleContext = createContext();

export const usePaginatedArticles = () => useContext(PaginatedArticleContext);

export const PaginatedArticleProvider = ({ children }) => {
  const [paginatedArticles, setPaginatedArticles] = useState([]);

  return (
    <PaginatedArticleContext.Provider
      value={[paginatedArticles, setPaginatedArticles]}
    >
      {children}
    </PaginatedArticleContext.Provider>
  );
};
